import React from "react";

import amity from "../IMG/Amity Logo.png";
import ecps from "../IMG/ECPS.png";

function Education() {
  return (
    <>
      {/* SEO META TAGS (NO UI CHANGE) */}


      {/* UI — EXACTLY THE SAME */}
      <div className="pb-6 px-4">
        <div className="pb-4 md:pb-4 md:pt-4 px-6 pt-2 bg-white shadow-md rounded-md">
          <div>
            <h1 className="text-xl font-bold text-gray-800 my-4 tracking-wide">
              Education
            </h1>

            <div className="space-y-6">
              {[
                {
                  img: amity,
                  institution: "Amity University, Noida",
                  degree:
                    "Integrated Bachelor’s and Master’s in Computer Applications, Computer Software Engineering",
                  duration: "July 2020 - May 2025",
                  grade: "9.08 CGPA",
                  activities:
                    "Class Representative – Facilitated communication between faculty and students and supported academic initiatives.\nVice-President, Cultural Club – Organized events and promoted student engagement.",
                  description:
                    "Awarded Silver Medal for securing second rank in the university, demonstrating consistent academic excellence and dedication.\nDeveloped strong analytical problem-solving skills, proficiency in Data Structures, Java, and full-stack development through coursework and projects.\nGained hands-on experience in software engineering, UI/UX design, and collaborative project work, preparing for real-world application development.\nEngaged in research and publications, including projects on real-time systems, secure banking authentication, and computer vision applications.",
                },
                {
                  img: ecps,
                  institution: "Ewing Christian Public School, Allahabad",
                  degree: "High and Senior Secondary Education (CBSE Board)",
                  duration: "April 2019 - March 2020",
                  grade: "7.36 CGPA",
                  activities:
                    "Vice Captain – Table Tennis\nProgram Co-ordinator",
                },
              ].map((edu, index) => (
                <div
                  key={index}
                  className="flex items-center space-x-4 p-5 bg-gray-50 rounded-md shadow-sm hover:shadow-md transition-all duration-200"
                >
                  <img
                    src={edu.img}
                    alt={`${edu.institution} logo`}
                    className="w-14 rounded-md"
                  />

                  <div className="flex-1">
                    <h2 className="text-xl font-semibold text-gray-800">
                      {edu.institution}
                    </h2>

                    <p className="text-lg font-semibold text-gray-700">
                      {edu.degree}
                    </p>

                    <p className="text-base text-gray-500 italic">
                      {edu.duration}
                    </p>

                    <p className="text-base text-gray-500">
                      Grade: 🎓 {edu.grade}
                    </p>

                    <div className="text-base text-gray-500 mt-2">
                      <span className="font-semibold text-black">
                        Activities
                      </span>
                      {edu.activities.split("\n").map((activity, i) => (
                        <span key={i} className="block">
                          {activity.trim()}
                        </span>
                      ))}
                    </div>

                    {edu.description && (
                      <div className="text-base text-gray-500 mt-2">
                        <span className="font-semibold text-black">
                          Description
                        </span>
                        {edu.description.split("\n").map((line, i) => (
                          <span key={i} className="block">
                            {line.trim()}
                          </span>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Education;
